import { Component, EventEmitter, Output } from '@angular/core';

// Interfaces
export interface ForgotPasswordDialogData {
    email: string;
}

@Component({
    selector: 'app-forgot-password-dialog',
    styleUrls: ['./forgot-password-dialog.component.scss'],
    templateUrl: './forgot-password-dialog.component.html',
})
export class ForgotPasswordDialogComponent {
    @Output() dialogAction = new EventEmitter<{ action: string; data?: any }>();

    public data: ForgotPasswordDialogData = { email: '' };

    // Public Methods
    public onCancelClick(): void {
        this.dialogAction.emit({ action: 'close' });
    }

    public onSendResetLink(): void {
        if (this.data.email && this.data.email.length) {
            this.dialogAction.emit({ action: 'close', data: this.data });
        }
    }
}
